import { render, staticRenderFns } from "./sethuokelink.vue?vue&type=template&id=5d70b49c&scoped=true"
import script from "./sethuokelink.vue?vue&type=script&lang=js"
export * from "./sethuokelink.vue?vue&type=script&lang=js"
import style0 from "./sethuokelink.vue?vue&type=style&index=0&id=5d70b49c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d70b49c",
  null
  
)

export default component.exports